import { ModelOptions } from './model-options';

export class DropdownModelOptions extends ModelOptions {
    public readonly maxEntries: number;
    public readonly maxSelections: number;
    public readonly required: boolean;
    public readonly disabled: boolean;
    public readonly patternScan: string;
    public readonly scannable: boolean;
    public readonly autoSelect: boolean;
    public readonly alwaysSelectedEntries: string[] = [];
    public readonly displayText: boolean;
    public readonly placeholder: string;
    public readonly minLength: number;
    public readonly maxLength: number;
    public readonly invalidSelection: boolean;

    public constructor({
        maxEntries = Infinity,
        maxSelections = 1,
        required = false,
        disabled = false,
        scannable = false,
        autoSelect = true,
        alwaysSelectedEntries = [],
        patternScan = '',
        displayText = false,
        placeholder = '',
        minLength = 0,
        maxLength = Infinity,
        invalidSelection = false,
    }: {
        maxEntries?: number;
        maxSelections?: number;
        required?: boolean;
        disabled?: boolean;
        scannable?: boolean;
        autoSelect?: boolean;
        alwaysSelectedEntries?: string[];
        patternScan?: string;
        displayText?: boolean;
        placeholder?: string;
        minLength?: number;
        maxLength?: number;
        invalidSelection?: boolean;
    } = {}) {
        super();
        this.maxEntries = maxEntries;
        this.maxSelections = maxSelections;
        this.required = required;
        this.disabled = disabled;
        this.scannable = scannable;
        this.autoSelect = autoSelect;
        this.alwaysSelectedEntries = alwaysSelectedEntries;
        this.patternScan = patternScan;
        this.displayText = displayText;
        this.placeholder = placeholder;
        this.minLength = minLength;
        this.maxLength = maxLength;
        this.invalidSelection = invalidSelection;
    }
}

export class DropdownModelOptionsFromJson extends DropdownModelOptions {
    public constructor(data: JsonDropdownModelOptions) {
        super({
            maxEntries: data.maxEntries ? data.maxEntries : Infinity,
            maxSelections: data.maxSelections ? data.maxSelections : Infinity,
            required: data.required,
            disabled: data.disabled,
            scannable: data.scannable,
            autoSelect: data.autoSelect,
            alwaysSelectedEntries: data.alwaysSelectedEntries,
            displayText: data.displayText,
            placeholder: data.placeholder,
            minLength: data.minLength,
            maxLength: data.maxLength ? data.maxLength : Infinity,
            invalidSelection: data.invalidSelection,
        });
    }
}

export interface JsonDropdownModelOptions {
    maxEntries: number;
    maxSelections: number;
    required: boolean;
    disabled: boolean;
    scannable: boolean;
    autoSelect: boolean;
    alwaysSelectedEntries: string[];
    displayText: boolean;
    placeholder: string;
    minLength: number;
    maxLength: number;
    invalidSelection: boolean;
}
